import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Box, CircularProgress, Typography } from '@mui/material';
import { authService } from '../services/authService';
import { appViewSetUser } from '../app/store/appViewSlice';
import { Routes } from '../routes';

// Local storage key to track if the user is new
const IS_NEW_USER_KEY = 'is_new_user';

const AuthCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Process the auth callback through our service
        const authResponse = await authService.handleAuthCallback(searchParams);

        // Store the token securely
        authService.storeToken(authResponse.token);

        console.log('Auth response user:', {
          email: authResponse.user.email,
          isNewUser: authResponse.user.isNewUser,
        });

        // Check if user is new and store that information
        if (authResponse.user.isNewUser) {
          console.log(`Setting new user flag for ${authResponse.user.email}`);
          localStorage.setItem(
            `${IS_NEW_USER_KEY}_${authResponse.user.email}`,
            'true',
          );

          // Verify the flag was set
          const flagSet = localStorage.getItem(
            `${IS_NEW_USER_KEY}_${authResponse.user.email}`,
          );
          console.log(`New user flag after setting: "${flagSet}"`);
        }

        // Update user data in Redux store
        dispatch(
          appViewSetUser({
            first_name: authResponse.user.firstName,
            last_name: authResponse.user.lastName,
            email: authResponse.user.email,
            image: '', // Set a default or placeholder image
          }),
        );

        // Redirect to home page or dashboard
        navigate(Routes.Root);
      } catch (error) {
        console.error('Error handling auth callback:', error);
        // Redirect to login page with error
        navigate(
          `${Routes.Login}?error=${encodeURIComponent('Authentication failed')}`,
        );
      }
    };

    handleCallback();
  }, [searchParams, navigate, dispatch]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
      }}
    >
      <CircularProgress size={60} />
      <Typography variant="h6" sx={{ mt: 2 }}>
        Completing authentication...
      </Typography>
    </Box>
  );
};

export default AuthCallback;
